import {FC} from "react";
import {ToggleBtnPanel} from "./styles";
import LogoIcon from "../../assets/icons/logo-gpb-circle.svg";
import ImgLogoMock from "../../assets/images/radar-logo-mock.svg";
import useFetchDataLogotypeGpb from "../../hooks/useFetchDataLogotypeGpb";

interface IProps {
  isOpenPanel: boolean;
}

export const SidebarLogoBlock: FC<IProps> = ({isOpenPanel}) => {
  const {settingData} = useFetchDataLogotypeGpb();

  const isShowLogotypeGpb = settingData?.data?.showGpb || false;
  return (
    <div
      className="d-flex flex-column justify-content-center py-3"
      style={{gap: 50, paddingLeft: "4px"}}
    >
      <ToggleBtnPanel
        isactive={isOpenPanel.toString()}
        addstyle="margin-top: 10px"
      >
        <img
          src={isShowLogotypeGpb ? LogoIcon : ImgLogoMock}
          alt="Logo"
          style={{width: "40px", height: "40px"}}
        />
        <span style={{fontSize: 20}}>Радар</span>
      </ToggleBtnPanel>
    </div>
  );
};
